import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSoyuzExperiment } from '@spotahome/soyuz/client';
import { showRebrandingToast } from '@spotahome/ui-library';

const STORAGE_VALUE = 1;

const RebrandingToast = ({ message, category, action }) => {
  const leadNurturingToast = useSoyuzExperiment('LeadNurturingToast');
  const isLNToast = leadNurturingToast.get('behaviour') === 'variant';
  const STORAGE_KEY = `ln-toast-${action}`;

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY) && isLNToast) {
      showRebrandingToast(
        { renderContent: () => message },
        {
          autoClose: true,
          openEvent: {
            category,
            action,
            label: 'Open'
          },
          closeEvent: {
            category,
            action,
            label: 'Close'
          }
        }
      );
      localStorage.setItem(STORAGE_KEY, STORAGE_VALUE);
    }
  }, []);

  return null;
};

RebrandingToast.propTypes = {
  message: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired
};

export default RebrandingToast;
